module.exports = __webpack_public_path__ + "media/flags/002-belgium-e032af51.svg";